module.exports = __webpack_public_path__ + "static/media/vertical-master-2.41786a24.svg";